export const STORE_RESPONDED = 'respondedSurveys';

export const ColorBrandPrimary = '#f163c1';
export const ColorBrandSecondary = '#01d2c5';

export const ScopingCostPerAddress = 0.03;
export const CommutingTripsPerYear = 364;
export const CycleCaloriesPerSecond = 0.1208333333333333;
export const WalkingCaloriesPerSecond = 0.07733333333333;

//Route Colours

export const RouteColors = {
  Bicycling: '#43888B',
  Walking: '#f163c1',
  Driving: '#cc4b37',
  Transit: '#01d2c5',
};
